import * as React from 'react';

type AppType = {
    title: string,
    description: string,
    space?: string
}

function AppTitle({ title, description, space = 'p-3' }:  AppType) {
    return (
        <div className='p-3 dark:text-white'>
            <h2 className='text-3xl'>{title}</h2>
            <p className='text-sm dark:text-gray-400'>{description}</p>
        </div>
    )
}

export default AppTitle